export default "__VITE_ASSET__Dnbh9vFN__"